import * as tslib_1 from "tslib";
import { Vector3D } from "@awayjs/core";
import { DisplayObjectNode } from "./DisplayObjectNode";
/**
 * @class away.partition.EntityNode
 */
var EntityNode = (function (_super) {
    tslib_1.__extends(EntityNode, _super);
    function EntityNode(displayObject, partition) {
        var _this = _super.call(this, displayObject, partition) || this;
        _this.numEntities = 1;
        _this._maskPosition = new Vector3D();
        _this._partition = partition;
        return _this;
    }
    EntityNode.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._partition = null;
    };
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     */
    EntityNode.prototype.isInFrustum = function (planes, numPlanes) {
        if (!this._entity._iIsVisible())
            return false;
        return true; // todo: hack for 2d. attention. might break stuff in 3d.
        //return this._bounds.isInFrustum(planes, numPlanes);
    };
    /**
     * @inheritDoc
     */
    EntityNode.prototype.isIntersectingRay = function (globalRayPosition, globalRayDirection) {
        if (!this._entity._iIsVisible() || !this.isIntersectingMasks(globalRayPosition, globalRayDirection, this._entity._iAssignedMasks()))
            return false;
        var pickingCollision = this._entity._iPickingCollision;
        pickingCollision.rayPosition = this._entity.transform.inverseConcatenatedMatrix3D.transformVector(globalRayPosition);
        pickingCollision.rayDirection = this._entity.transform.inverseConcatenatedMatrix3D.deltaTransformVector(globalRayDirection);
        if (!pickingCollision.normal)
            pickingCollision.normal = new Vector3D();
        var rayEntryDistance = this.bounds.rayIntersection(pickingCollision.rayPosition, pickingCollision.rayDirection, pickingCollision.normal);
        if (rayEntryDistance < 0)
            return false;
        pickingCollision.rayEntryDistance = rayEntryDistance;
        pickingCollision.globalRayPosition = globalRayPosition;
        pickingCollision.globalRayDirection = globalRayDirection;
        pickingCollision.rayOriginIsInsideBounds = rayEntryDistance == 0;
        return true;
    };
    /**
     *
     * @returns {boolean}
     */
    EntityNode.prototype.isRenderable = function () {
        return this._entity._iAssignedColorTransform()._isRenderable();
    };
    /**
     * @inheritDoc
     */
    EntityNode.prototype.acceptTraverser = function (traverser) {
        if (traverser.enterNode(this))
            traverser[this._entity.traverseName](this._entity);
    };
    EntityNode.prototype._onInvalidatePartitionBounds = function (event) {
        this.bounds.invalidate();
        this._partition.invalidateEntity(this._entity);
    };
    EntityNode.prototype.isIntersectingMasks = function (globalRayPosition, globalRayDirection, masks) {
        //horrible hack for 2d masks
        if (masks != null) {
            this._maskPosition.x = globalRayPosition.x + globalRayDirection.x * 1000;
            this._maskPosition.y = globalRayPosition.y + globalRayDirection.y * 1000;
            var numLayers = masks.length;
            var children;
            var numChildren;
            var layerHit;
            for (var i = 0; i < numLayers; i++) {
                children = masks[i];
                numChildren = children.length;
                layerHit = false;
                for (var j = 0; j < numChildren; j++) {
                    if (children[j].hitTestPoint(this._maskPosition.x, this._maskPosition.y, true, true)) {
                        layerHit = true;
                        break;
                    }
                }
                if (!layerHit)
                    return false;
            }
        }
        return true;
    };
    return EntityNode;
}(DisplayObjectNode));
export { EntityNode };



// WEBPACK FOOTER //
// ../dist/lib/partition/EntityNode.js